export default "__VITE_ASSET__BmFbkAxt__"